import './Spinner.bcd65df0b03c1dc230de2d8bbff67aef.css';
export default {"colorInteraction":"var(--color-primary, #579eb0)","spinner":"_spinner_y5wp1_1","rotate":"_rotate_y5wp1_1"};